import React, {useEffect, useMemo, useState} from 'react'
import ClientsList from "./clientslist";
import ClientModalBox from "../elements/clientmodalbox";
import {Carcontext} from "../context/carcontext";
import {fetchCars, fetchClients, showAlert} from "../redux/actions";
import Alert from "../elements/alert";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {TOGGLE_FALSE_LOGGED_CLIENT} from "../redux/types";

const search = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"></path></svg>
const resetIcon = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="redo" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M492 8h-10c-6.627 0-12 5.373-12 12v110.625C426.804 57.047 346.761 7.715 255.207 8.001 118.82 8.428 7.787 120.009 8 256.396 8.214 393.181 119.166 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-7.069-7.069c-4.503-4.503-11.749-4.714-16.482-.454C361.218 449.238 311.065 470 256 470c-117.744 0-214-95.331-214-214 0-117.744 95.331-214 214-214 82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12z"></path></svg>
const logout = <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="sign-out-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor"d="M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z"></path></svg>

const ClientsPage = () => {

    const {t} = useTranslation()
    const dispatch = useDispatch()
    const [modal, setModal] = useState({})
    const [passportData, setPassportData] = useState('')
    const [clientContext, setClientContext] = useState(null)
    const alertBox = useSelector(state => state.app.alertBox)
    const loggedClient = useSelector(state => state.clients.isLoggedIn)
    const theme = useSelector(state => state.app.theme)
    const paginationData = useSelector(state => state.clients.paginationData)

    useEffect(() => {
        const modal = document.querySelector('.modal-wrapper')
        setModal(modal)
    }, [])

    const OpenUserModal = (client) => {
        modal.style.cssText = "opacity: 1; visibility: visible;"
        setClientContext(client)
    }

    const CloseModal = () => {
        modal.style.cssText = "opacity: 0; visibility: hidden;";
    }

    const userModal = useMemo(() => {
        return <ClientModalBox clients={clientContext} theme={theme}/>
    }, [clientContext, theme])

    const handleChanges = event => {
        setPassportData(event.target.value)
    }

    const searchPassport = (e) => {
        e.preventDefault()
        dispatch(fetchClients(passportData))
    }

    const reset = (e) => {
        e.preventDefault()
        if (passportData.length) {
            setPassportData('')
            dispatch(fetchClients())
        }
    }

    const logOutFromProfile = () => {
        dispatch({type: TOGGLE_FALSE_LOGGED_CLIENT})
        dispatch(showAlert('You have logged out!', 'warning'))
        localStorage.removeItem('newCreatedUserData')
    }

    const nextPage = (nextPage) => {
        dispatch(fetchClients(null, nextPage))
    }

    return (
        <Carcontext.Provider value={{
            OpenUserModal, CloseModal, theme
        }}>
            <div className="content">
                {alertBox && <Alert text={alertBox.text} type={alertBox.type}/>}
                <div className="wrapper">
                    <div className="modal-wrapper">
                        {userModal}
                    </div>
                    <div className="top-tools">
                        <div className={`tools-inner clients ${theme}`}>
                            <div className="tools-item">
                                <input
                                    type="text"
                                    placeholder="Passport or Firstname"
                                    name='passportData'
                                    value={passportData}
                                    onChange={handleChanges}
                                />
                            </div>
                            <div className="tools-item buttons">
                                <button onClick={searchPassport} className="search-btn">{search}</button>
                                <button onClick={reset} className="search-btn">{resetIcon}</button>
                            </div>
                        </div>
                    </div>
                    <h2 className={`carSelectionFor ${theme}`}>
                        {
                            (() => {
                                if (loggedClient) {
                                    return (
                                        <>
                                            {t('carSeletionForUser')} <br/>
                                            {t('logOutFromProfile')} : <div className="userLogOut" onClick={logOutFromProfile}><p>{t('logOut')}</p>{logout}</div>
                                        </>
                                    )
                                } else {
                                    return (
                                        <>
                                            {t('selectAPerson')}
                                        </>
                                    )
                                }
                            }) ()
                        }
                    </h2>
                    <ClientsList />
                    <div className={`pagination-items ${theme}`}>
                        {
                            !!paginationData.previous ? <div className="previos-page" onClick={() => nextPage(paginationData.previous)}>{t('previous')}</div> : ''
                        }
                        {
                            !!paginationData.next ? <div className="next-page" onClick={() => nextPage(paginationData.next)}>{t('next')}</div> : ''
                        }
                    </div>
                </div>
            </div>
        </Carcontext.Provider>
    )
}

export default ClientsPage
